import React, { useEffect, useState, useRef } from "react";
import { secretKey } from "../.././data";
import LoadingPopup from "../helpers/loading_component.js";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal2);

const AdminPanelHolidays = (props) => {
  const [users, setUsers] = useState([]);
  const [yearHolidays, setYearHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear());

  const fetchUsers = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getUsers", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        fetchYearHolidays();
      })
      .catch((error) => {});
  };

  const fetchYearHolidays = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getYearsHolidays", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setYearHolidays(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchUsers();
  };

  useEffect(() => {
    getData();
  }, []);

  const getDays = (name) => {
    var days = yearHolidays.filter(
      (el) => el.name === name && +el.year === +year
    )[0];
    return days === undefined ? 0 : days.days;
  };

  const handleYearChange = (e) => {
    setLoading(true);
    setYear(e.target.value);
    setLoading(false);
  };

  const changeDays = async (e) => {
    var days = e.currentTarget.value;
    var name = e.currentTarget.attributes.fieldUID.value;

    MySwal.fire({
      title: "Wprowadź nową wartość",
      text: "",
      input: "text",
      inputPlaceholder: days,
      inputValue: days,
      showCancelButton: true,
      cancelButtonText: "Anuluj",
      inputValidator: function (value) {
        return new Promise(function (resolve, reject) {
          if (value !== "") {
            resolve();
          } else {
            resolve("musisz podać wartość");
          }
        });
      },
    }).then(async function (result) {
      if (result.isConfirmed) {
        var value = result.value;

        var body = {
          days: value,
          name: name,
          year: year,
        };

        await fetch("https://apidevkppp.ftpeople.pl/updateYearHoliday", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: secretKey,
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.text())
          .then((data) => {
            getData();
          })
          .catch((error) => {});
      }
    });
  };

  const usersTableFirst = (
    <table id="detailClientTable" className="clients_table">
      <tr>
        <th>Lp.</th>
        <th>Nazwa</th>
        <th>Ilość dni urlopu</th>
      </tr>
      {users.map((el, index) => (
        <>
          <tr>
            <td style={{ width: "2%", textAlign: "center", paddingLeft: "0" }}>
              {index + 1}
            </td>
            <td
              style={{ width: "15%", textAlign: "left", paddingLeft: "10px" }}
            >
              {el.name}
            </td>
            <td
              style={{ width: "5%", textAlign: "center", paddingLeft: "10px" }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  width: "90%",
                }}
              >
                <div
                  style={{
                    width: "80%",
                    display: "flex",
                    justifyContent: "left",
                  }}
                >
                  {getDays(el.name)}
                </div>
                <div
                  style={{
                    width: "20%",
                    display: "flex",
                    justifyContent: "right",
                  }}
                >
                  <button
                    style={{
                      marginLeft: "10px",
                      width: "10%",
                      backgroundColor: "transparent",
                      color: "#a5bea4",
                      border: "none",
                      fontSize: "1vw",
                    }}
                    id="clientsButton"
                    className="paymentMenuButton"
                    desc={""}
                    value={getDays(el.name)}
                    fieldUID={el.name}
                    onClick={changeDays}
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </>
      ))}
    </table>
  );

  return (
    <>
      <div className="mainContainerPayments">
        {loading ? (
          <>
            <LoadingPopup />
          </>
        ) : (
          <>
            <select
              type="text"
              id="court"
              name="court"
              value={year}
              onChange={handleYearChange}
              style={{ width: "30%", marginBottom: "4vh" }}
            >
              <option key={1} value={new Date().getFullYear() - 2}>
                {new Date().getFullYear() - 2}
              </option>
              <option key={2} value={new Date().getFullYear() - 1}>
                {new Date().getFullYear() - 1}
              </option>
              <option key={3} value={new Date().getFullYear()}>
                {new Date().getFullYear()}
              </option>
              <option key={4} value={new Date().getFullYear() + 1}>
                {new Date().getFullYear() + 1}
              </option>
              <option key={5} value={new Date().getFullYear() + 2}>
                {new Date().getFullYear() + 2}
              </option>
            </select>
            <div
              style={{
                height: "5vh",
                fontSize: "2vw",
                fontWeight: "600",
                paddingBottom: "2vh",
              }}
            >
              Liczba dni urlopów
            </div>
            {usersTableFirst}
          </>
        )}
      </div>
    </>
  );
};

export default AdminPanelHolidays;
